import { useQuery } from '@tanstack/react-query'

import { DefaultApiGetBalanceStateRequest } from '@src/api/generated/user-api'
import { getBalanceState } from '@src/api/repositories'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchBalanceState = (
  params: DefaultApiGetBalanceStateRequest
) => {
  const { axiosInstance } = useAxios()
  const { organizationId, ...queryParameter } = params

  return useQuery({
    enabled: !!organizationId,
    queryFn: () => getBalanceState(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_BALANCE_STATE,
      params.organizationId,
      queryParameter,
    ],
  })
}
